export enum TrafficLightStatus {
  UNSET = 'UNSET',
  NEUTRAL = 'NEUTRAL',
  GREEN = 'GREEN',
  YELLOW = 'YELLOW',
  RED = 'RED',
}
